import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../redux/store'

export const retrieveCcamCategoryLabels = createAsyncThunk<
  string[],
  void,
  ThunkConfig
>('simulation/retrieveCcamCategoryLabels', async (_, { extra }) => {
  const labels = await extra.simulationGateway.fetchCcamCategoryLabels()
  return labels
})
